// Runtime env detection based on hostname.
// Prod and QA share NODE_ENV=production in the container, so we distinguish by URL.
const PROD_HOSTS = new Set([
  'connect.newtonhealthcore.com',
]);

const QA_HOSTS = new Set([
  'connect-qa.newtonhealthcore.com',
]);

export function getEnvName() {
  if (typeof window === 'undefined') return 'unknown';
  const h = window.location.hostname;
  if (PROD_HOSTS.has(h)) return 'prod';
  if (QA_HOSTS.has(h)) return 'qa';
  if (h === 'localhost' || h === '127.0.0.1') return 'local';
  return 'unknown';
}

export function isProdEnv() {
  return getEnvName() === 'prod';
}

// Nav v2 feature flag — checked at render time by Sidebar so we can dogfood the new IA
// on QA without deploying it to prod. Toggle via localStorage or `?navV2=1`.
export function isNavV2Enabled() {
  if (typeof window === 'undefined') return false;
  try {
    if (new URLSearchParams(window.location.search).get('navV2') === '1') return true;
    return localStorage.getItem('nav_v2') === 'true';
  } catch {
    return false;
  }
}

export function setNavV2Enabled(on) {
  try {
    if (on) localStorage.setItem('nav_v2', 'true');
    else localStorage.removeItem('nav_v2');
  } catch {}
}
